module.exports = __webpack_public_path__ + "img/resume.77c56148.png";